import { AppStorage } from '../interfaces/host';
import { JWT, BASE_URL } from '../constants';
import { USER_PERMISSIONS } from '../interfaces/global';

export const mockAppStorage: AppStorage = {
  dataUser: {
    id: 2,
    name: 'David Ramirez',
    email: 'david.ramirez@rappi.com',
    profile_pic: null,
    country_code: 'DEV',
    permissions: getUserPermission(),
    suppliers: getSupplier()
  },
  tokenClaims: getUserToken(),
  baseUrl: BASE_URL
};

function getUserPermission(): string[] {
  const mockedPermissionSets = {
    SUPERADMIN: [USER_PERMISSIONS.SUPERADMIN],
    SUPPLIER_ACCESS: [USER_PERMISSIONS.SUPPLIER_ACCESS],
    FINANCIAL_NO_AUDIT: [USER_PERMISSIONS.FINANCIAL_ACCESS],
    FINANCIAL_WITH_AUDIT: [USER_PERMISSIONS.FINANCIAL_ACCESS, USER_PERMISSIONS.AUDIT_ACCESS],
    AUDIT_ACCESS: [USER_PERMISSIONS.AUDIT_ACCESS]
  };
  // Different permissions can be set here test locally
  return mockedPermissionSets.SUPERADMIN;
}

function getSupplier(): number[] {
  return [10, 11];
}

function getUserToken() {
  return JWT;
}
